// Supplier-advertised specifications. Every entry is editable and
// must be validated before publication (status: 'supplier').

export type Spec = {
  label: string;
  labelEs: string;
  value: string;
  status: 'verified' | 'supplier';
};

export const m1ProSpecs: Spec[] = [
  { label: 'LED lenses', labelEs: 'Lentes LED', value: '13', status: 'supplier' },
  { label: 'LED type', labelEs: 'Tipo de LED', value: '5050', status: 'supplier' },
  { label: 'Power', labelEs: 'Potencia', value: '3 W', status: 'supplier' },
  { label: 'Voltage', labelEs: 'Voltaje', value: '5 V', status: 'supplier' },
  { label: 'Battery', labelEs: 'Batería', value: '3000 mAh rechargeable', status: 'supplier' },
  { label: 'Charging', labelEs: 'Carga', value: 'USB-C', status: 'supplier' },
  { label: 'Ingress protection', labelEs: 'Protección', value: 'IP68 (advertised)', status: 'supplier' },
  { label: 'Color options', labelEs: 'Colores', value: '16 (advertised)', status: 'supplier' },
  { label: 'Run time', labelEs: 'Autonomía', value: 'Up to 20 h (advertised, conditions apply)', status: 'supplier' },
  { label: 'Diameter', labelEs: 'Diámetro', value: '3.3 in / 8.38 cm', status: 'supplier' },
  { label: 'Thickness', labelEs: 'Grosor', value: '1.2 in / 3.05 cm', status: 'supplier' },
  { label: 'Housing', labelEs: 'Carcasa', value: 'White ABS', status: 'supplier' },
  { label: 'Mounting', labelEs: 'Montaje', value: 'Magnetic Mount System', status: 'supplier' },
];
